import React from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage } from 'react-intl'

const CheckInput = props => {
  const {
    containerClass,
    name,
    checked,
    onBlur,
    onChange,
    label,
    id,
    required,
    'aria-required': ariaRequired,
    'aria-invalid': ariaInvalid,
    'aria-describedby': ariaDescribedBy,
  } = props

  const fieldId = id || name
  const isRequired = required || ariaRequired

  return (
    <div className={`amd-check-container ${containerClass || ''}`}>
      <input
        type="checkbox"
        className="form-check-input amd-check"
        id={fieldId}
        name={name}
        checked={checked}
        onBlur={onBlur}
        onChange={onChange}
        required={isRequired}
        aria-required={isRequired}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
      />
      <label className="form-check-label" htmlFor={fieldId}>
        <p>
          <FormattedHTMLMessage id={label} />
          {isRequired && (
            <span className="required-indicator" aria-hidden="true">
              *
            </span>
          )}
        </p>
      </label>
    </div>
  )
}

CheckInput.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.string,
  options: PropTypes.array,
  containerClass: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
  'aria-required': PropTypes.bool,
  'aria-invalid': PropTypes.bool,
  'aria-describedby': PropTypes.string,
}

export default CheckInput
